module.exports = __webpack_public_path__ + "img/logo-zc-edasinvoize-dark.9b20b602.webp";